export const HOURS_FORMAT = 'hh A';
export const DAY_MONTH_FORMAT = 'MMM DD';
export const DAY_NAME_FORMAT = 'ddd DD';
export const MONTH_SHORT_FORMAT = 'MMM';
export const MONTH_LONG_FORMAT = 'MMM YYYY';

export const DAY_RANGE_LIMITER = 31;
export const WEEK_RANGE_LIMITER = 90;
